export default __webpack_public_path__ + "static/media/portada_TonyEsposito_ENG.361460b6.jpg";